// frontend/src/components/grid/SkeletonCell.jsx
// AG Grid loadingCellRenderer for SSRM rows that are still being fetched.
// Shown only briefly when scrolling fast through a page that's mid-block-fetch;
// the LoadingOverlay covers the more common case of an empty grid on first paint.

import './GridOverlays.css';

export default function SkeletonCell() {
  return (
    <div className="grid-loading-cell" role="presentation" aria-busy="true">
      <div className="grid-loading-cell-bar" />
    </div>
  );
}
